module.exports = __webpack_public_path__ + "entry-150bfe9b/Background_01_1x1_a-268a924c816c338c3a216bc81d280144.svg";